module.exports = __webpack_public_path__ + "static/d-KCortez-edcc77ee1d273320244ab2886ea81854.jpg";